import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BadgesTab } from "@/components/stats/BadgesTab";
import { StoryStatsTab } from "@/components/stats/StoryStatsTab";
import { CharacterStatsTab } from "@/components/stats/CharacterStatsTab";
import { EngagementTab } from "@/components/stats/EngagementTab";
import { Award, BookOpen, User2, Activity } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const StatsPage = () => {
  const { t } = useLanguage();

  return (
    <div className="py-8 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <Tabs defaultValue="badges" className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:grid-cols-3 bg-white/5 p-2 h-auto">
          <TabsTrigger value="badges" className="data-[state=active]:bg-white/10">
            <Award className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t("dashboard.stats.tabs.badges")}</span>
          </TabsTrigger>
          <TabsTrigger value="stories" className="data-[state=active]:bg-white/10">
            <BookOpen className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t("dashboard.stats.tabs.stories")}</span>
          </TabsTrigger>
          <TabsTrigger value="characters" className="data-[state=active]:bg-white/10">
            <User2 className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t("dashboard.stats.tabs.characters")}</span>
          </TabsTrigger>
          {/* <TabsTrigger value="engagement" className="data-[state=active]:bg-white/10">
            <Activity className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t("dashboard.stats.tabs.engagement")}</span>
          </TabsTrigger> */}
        </TabsList>

        <div className="mt-6">
          <TabsContent value="badges">
            <BadgesTab />
          </TabsContent>
          <TabsContent value="stories">
            <StoryStatsTab />
          </TabsContent>
          <TabsContent value="characters">
            <CharacterStatsTab />
          </TabsContent>
          {/* <TabsContent value="engagement">
            <EngagementTab />
          </TabsContent> */}
        </div>
      </Tabs>
    </div>
  );
};

export default StatsPage;
